// src/components/Modals/PastDueModal.component.tsx
import React, { useMemo } from 'react';
import { Button, Modal } from 'react-daisyui';
import { useModalsContext } from '../../../ModalsProvider/Modals.context';
import { useUserContext } from '../../../UserProvider/User.context';
import { useSubscriptionContext } from '../../Subscription.context';
import WarningIcon from '../../../../assets/warningIcon.svg';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { eUserRole } from '../../../UserProvider/User.enums';
import { useNavigate } from 'react-router-dom';
import { RouterPaths } from '../../../../components/Router/Router.constants';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import './SubscriptionModals.styles.scss';

export default function PastDueModal(): React.ReactElement {
  const { t } = useTranslation('settings/subscriptionsModals');
  const { subscription, markNotificationAsRead } = useSubscriptionContext();
  const { currentUserRole, currentUser } = useUserContext();
  const { showPastDueModal, togglePastDueModal } = useModalsContext();
  const navigate = useNavigate();

  const cancellationDays = Number(import.meta.env.VITE_CANCELLATION_DAYS) || 10;
  const cancellationDate = useMemo(
    () =>
      subscription.endDate
        ? moment(subscription.endDate).add(cancellationDays, 'days').toDate()
        : null,
    [subscription.endDate, cancellationDays],
  );

  const isOwner = currentUserRole === eUserRole.OWNER;

  return (
    <Modal open={showPastDueModal} backdrop={!isOwner}>
      <Modal.Header className="PastDueModal__header">
        {t('pastDueModal.title')}
        {!isOwner && (
          <XMarkIcon
            onClick={() => togglePastDueModal(false)}
            className="PastDueModal__closeIcon"
          />
        )}
      </Modal.Header>

      <Modal.Body className="PastDueModal__content">
        <WarningIcon />
        <p>{t('pastDueModal.greeting', { name: currentUser?.name })}</p>
        <p className="font-bold">{t('pastDueModal.expired')}</p>
        <p className="text-center">
          {t('pastDueModal.body', {
            date: cancellationDate
              ? cancellationDate.toLocaleString('es-MX', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })
              : '',
          })}
        </p>
      </Modal.Body>

      {isOwner && (
        <Modal.Actions>
          <Button
            color="primary"
            onClick={() => {
              markNotificationAsRead();
              navigate(RouterPaths.settings);
              togglePastDueModal(false);
            }}
          >
            {t('pastDueModal.button')}
          </Button>
        </Modal.Actions>
      )}
    </Modal>
  );
}
